const offer = document.querySelector('[data-note-welcome-offer]');

if (offer instanceof HTMLDialogElement) {
  const storageKey = 'note-welcome-offer-dismissed';
  const dismissedAt = Number(localStorage.getItem(storageKey) || 0);
  const dismissedRecently = Date.now() - dismissedAt < 7 * 24 * 60 * 60 * 1000;
  const delay = Number(offer.dataset.delay || 8000);

  offer.querySelectorAll('[data-note-offer-close]').forEach((button) => {
    button.addEventListener('click', () => {
      localStorage.setItem(storageKey, String(Date.now()));
      offer.close();
    });
  });

  offer.addEventListener('click', (event) => {
    if (event.target === offer) {
      localStorage.setItem(storageKey, String(Date.now()));
      offer.close();
    }
  });

  if (!dismissedRecently) {
    window.setTimeout(() => {
      if (!offer.open) offer.showModal();
    }, delay);
  }
}
